/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpdescription2Inputs */

const en_crosspostinghelpdescription2 = /** @type {(inputs: Crosspostinghelpdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What you need so Facebook and Instagram connect on the first try.`)
};

const de_crosspostinghelpdescription2 = /** @type {(inputs: Crosspostinghelpdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was du brauchst, damit Facebook und Instagram auf Anhieb verbinden.`)
};

/**
* | output |
* | --- |
* | "What you need so Facebook and Instagram connect on the first try." |
*
* @param {Crosspostinghelpdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpdescription2 = /** @type {((inputs?: Crosspostinghelpdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpdescription2(inputs)
	return de_crosspostinghelpdescription2(inputs)
});
export { crosspostinghelpdescription2 as "crosspostingHelpDescription" }